export const CREDIT_PROVIDER_OPTIONS = [
  { value: 'FactualData', name: 'FactualData' },
  { value: 'AdvantageCredit', name: 'Advantage Credit' },
  { value: 'LendersOne', name: 'LendersOne' },
  { value: 'XedaLink', name: 'XedaLink' },
];

export const CREDIT_PROPERTY_KEYS = {
  CREDIT_REPORT_PROVIDER: 'CreditReportProvider',
  CREDIT_PROVIDER_USERNAME: 'CreditProviderUsername',
  CREDIT_PROVIDER_PASSWORD: 'CreditProviderPassword',
  CREDIT_PROVIDER_USE_TEST: 'CreditProviderUseTest',
};
